import { CALCULATE_PAYABLE_FAILED, CALCULATE_PAYABLE_LOADING, CALCULATE_PAYABLE_SUCCESS } from '../actions/whatsappDeduction.action';
import { whatsappDeduction } from '../models/whatsappDeduction.interface';

const initialState: whatsappDeduction = {
    isLoading: true,
    error: false,
    errorMsg:'',
    payableData: []
}

const whatsappDeductionReducer = (state: whatsappDeduction = initialState, action: any) : whatsappDeduction => {

    switch(action.type){
        case CALCULATE_PAYABLE_LOADING:
            return {
                ...state,
                isLoading: true,
                error: false
            }
        case CALCULATE_PAYABLE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                error: false,
                payableData: action.payload.res
            }
        case CALCULATE_PAYABLE_FAILED:
            return {
                ...state,
                isLoading: false,
                error: true,
                errorMsg: action.payload.error.message || ""
            }
        default:
            return state;
    }
}

export default whatsappDeductionReducer;